import { create } from 'zustand';
import { createSelectors, StoreName, withDevtools } from '../config';

import {
  createInspectionSlice,
  InspectionSlice,
  InspectionSubmitSlice,
} from './slices/inspection';

import {
  createInspectionsSlice,
  InspectionsSlice,
} from './slices/inspections';

import {
  createInspectionTemplateSlice,
  InspectionTemplateSlice,
} from './slices/inspectionTemplate';

import {
  createInspectionTemplatesSlice,
  InspectionTemplatesSlice,
} from './slices/inspectionTemplates';

export type InspectionStoreState = InspectionSlice &
  InspectionsSlice &
  InspectionSubmitSlice &
  InspectionTemplateSlice &
  InspectionTemplatesSlice & {
    reset: () => void;
  };

export const useInspectionStore = createSelectors(
  create<InspectionStoreState>()(
    withDevtools(
      (set, get, store) => ({
        ...createInspectionSlice(set, get, store),
        ...createInspectionsSlice(set, get, store),
        ...createInspectionTemplateSlice(set, get, store),
        ...createInspectionTemplatesSlice(set, get, store),

        reset: () => {
          const state = get();
          state.resetInspection();
          state.resetInspections();
          state.resetInspectionSaving();
          state.resetInspectionTemplate();
          state.resetInspectionTemplates();
        },
      }),
      StoreName.Inspection
    )
  )
);

export const getInspectionStoreState = (): InspectionStoreState =>
  useInspectionStore.getState();
